export default __webpack_public_path__ + "static/everett-light-webfont-1f251080c5fc6a1b9520a1bd40afbba8.woff";